"use client";

import { useInboxNotificationsContext } from "@/context/InboxNotificationsContext";

export default function useInboxNotifications() {
  return useInboxNotificationsContext();
}
